/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestStateOntology } from '../../models/export-request-state-ontology';

export interface AddStateOntologyExportRequest$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
  
    /**
     * Body for new ontology on demand of export
     */
    body: ExportRequestStateOntology
}

export function addStateOntologyExportRequest(http: HttpClient, rootUrl: string, params: AddStateOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestStateOntology>> {
  const rb = new RequestBuilder(rootUrl, addStateOntologyExportRequest.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportRequestStateOntology>;
    })
  );
}

addStateOntologyExportRequest.PATH = '/custom/export-request/{uid}/ontology/state';
